import TopPromotedProduct from "./TopPromotedProduct";
export default TopPromotedProduct;
